import { GLOBAL_EVENTS } from '../cfg/constants/global-events';
import { GameComponents } from '../game-objects/GameComponents';
export class GameManager {
    constructor(scene) {
        this.scene = scene;
        this.gameComponents = new GameComponents(this.scene);
        this.addGlobalEventHandlers();
    }
    addGlobalEventHandlers() {
        this.scene.globalEvents
            .on(GLOBAL_EVENTS.DISABLE_INPUT, () => {
            this.scene.input.enabled = false;
        })
            .on(GLOBAL_EVENTS.ENABLE_INPUT, () => {
            this.scene.input.enabled = true;
        })
            .on(GLOBAL_EVENTS.SETUP_GAME, () => {
        })
            .on(GLOBAL_EVENTS.START_GAME, () => {
            this.gameComponents.startGame();
        })
            .on(GLOBAL_EVENTS.END_GAME, () => {
            this.gameComponents.endGame();
        });
    }
    cleanUp() {
        this.gameCleanUp();
    }
    gameCleanUp() {
        this.gameComponents.gameCleanUp();
    }
    resizeAndRepositionElements(w, h) {
        this.gameComponents.resizeAndRepositionElements(w, h);
    }
    update(delta) {
        this.gameComponents.update(delta);
    }
}
